import api from './client';

const PRODUCTS_TIMEOUT_MS = 45000;

/**
 * Fetch products. Optionally filter by store when backend supports storeId.
 * @param {object} params - query params (e.g. storeId)
 * @param {object} [axiosConfig] - extra axios options (timeout merged with default)
 */
export async function fetchProducts(params = {}, axiosConfig = {}) {
  const { data } = await api.get('/api/products', {
    params,
    timeout: axiosConfig.timeout ?? PRODUCTS_TIMEOUT_MS,
    ...axiosConfig
  });
  return data;
}

export async function fetchProductById(id, params = {}) {
  const { data } = await api.get(`/api/products/${id}`, { params });
  return data;
}

export async function fetchProductComments(id, params = {}, axiosConfig = {}) {
  const { data } = await api.get(`/api/products/${id}/comments`, {
    params,
    timeout: 15000,
    ...axiosConfig,
  });
  return Array.isArray(data?.comments) ? data.comments : [];
}
